import WeekRangeDatePicker from './WeekRangeDatePicker';

export default WeekRangeDatePicker;
